module.exports = __webpack_public_path__ + "media/images/img/rikunabi-0868e1d814d00da08cfd4d4b11a3a939.svg";